<template>
<v-card flat>
	<request-status :request='saveReq' />
  <request-status
    :request='getReq'
    message404='Unable to load settings' />
  <!-- <v-card-title >
    {{spaceId}}
    <v-btn @click='get' >refresh</v-btn>
  </v-card-title> -->
  <template v-if='getReq.status === 404' >
    <v-card-text >
      Unable to load settings.
      You might not have permission to edit these settings.
      You need to be an owner in order edit settings
    </v-card-text>
    <v-card-actions>
      <v-btn flat v-if='withClose' @click='$emit("close")' >Close</v-btn>
    </v-card-actions>
  </template>
  <template v-else >
    <v-card-text v-if='settings && settings.id' >
      <!-- S:{{spaceId}} | {{settings.id}} -->
      <template >
        <v-list class='elevation-5 pa-0' >
          <v-list-tile @click='uploadLogo=true'  >
            <v-list-tile-avatar >
              <v-img
                v-if='resizedLogoPicture'
                :src='resizedLogoPicture' />
              <v-icon v-else >face</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content v-if='logoPicture' >
              <v-list-tile-title>Your logo</v-list-tile-title>
              <v-list-tile-sub-title>Click to change</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-content v-else >
              <v-list-tile-title>No logo</v-list-tile-title>
              <v-list-tile-sub-title>Click to upload</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action >
              <v-icon>upload</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        <v-dialog v-model='uploadLogo' width=400 >
          <v-card flat >
            <v-card-title class='overline py-0 mb-0 grey lighten-4' >
              Upload a logo
              <v-spacer/>
              <v-btn icon small @click='uploadLogo=false' small icon >
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <uploader
              @uploadsuccess='get'
              :upload-path='logoUploadPath'
              title='Upload a logo'
              subtitle='The logo should be a rectangle (for best results) and it will be used on your invoices and free website.'
              filename='logo_picture' >
            </uploader>
          </v-card>
        </v-dialog>
      </template>

      <!-- <pre v-text='value' /> -->
      <object-form
        v-if='settings'
        v-model='settings'
        :field-configs="config"
        :fields="fields"
        @valid='setValid' >

        <v-checkbox
          v-model='settings.include_booking_info'
          slot='include_booking_info'
          hint = "A link to your website is added to the bottom of invoices"
          persistent-hint
          label='Show online booking details' >
        </v-checkbox>
        <v-checkbox
          v-model='settings.integrate_medical_aid'
          slot='integrate_medical_aid'
          hint="If checked, then we'll show medical aid information on invoices"
          persistent-hint
          label='Include medical information' >
        </v-checkbox>

        <!-- uncommment value in fields to enable this -->
        <v-checkbox
          v-model='settings.allow_submit_to_medical_aid'
          slot='allow_submit_to_medical_aid'
          hint="Your clients can submit the invoice to medical aids at the click of a button!"
          persistent-hint
          label='Submit to medical aids' >
        </v-checkbox>

      </object-form >
    </v-card-text>
    <v-card-actions>
      <v-btn flat v-if='withClose' @click='$emit("close")' >Close</v-btn>
      <v-spacer></v-spacer>
      <v-btn
        @click='save'
        :loading='saveReq.loading'
        :disabled='!isValid || getReq.loading'
        class='primary' >Save</v-btn>
    </v-card-actions>
  </template>


</v-card>
</template>

<script>
import ObjectForm from '@/components/medicalaid/ObjectForm'
import Uploader from '@/components/pages/settings/media/Uploader'

import Vue from 'vue'

export default {
  name: 'InvoiceSettings',
  components: {ObjectForm, Uploader},
  props: {
    value: { required: true },
    spaceId: { required: true },
    // touch: {type: Number, default: 10},
    withClose: {type: Boolean, default: true},
    closeOnSave: {type: Boolean, default: true}
  },
  data () {
    return {
      isValid: false,
      uploadLogo: false,
      settings: {
        override_practitioner_settings: true
      },
      snackbar: false,
      color: null,
      resultMessage: null,
      logoPicture: null,
      getReq: {
        resource: 'ag.spaces.settings'
      },
      saveReq: {
        resource: 'ag.spaces.settings'
      },
      fields: [
        // 'logo_picture',
        'practice_name',
        'practice_number',
        'banking_details',
        'billing_address',
        'invoice_notes',
        'receipt_notes',
        // 'statement_notes',
        'include_booking_info',
        'integrate_medical_aid'
        // 'allow_submit_to_medical_aid',
        // 'show_snapcode_on_invoice',
        // 'snap_id'
      ],
      config: {
        'practice_name': {
          hint: 'Practice or business name as you would like to display it on your invoice',
          persistentHint: true,
          flexAttrs: { sm6: true }
        },
        'practice_number': {
          hint: '(if relevant) - your registered practice number',
          persistentHint: true,
          flexAttrs: { sm6: true }
        },
        'banking_details': {
          type: 'vtextarea',
          hint: 'Added to your invoices so that people know how to pay you',
          persistentHint: true,
          flexAttrs: { sm6: true }
        },
        'billing_address': {
          type: 'vtextarea',
          flexAttrs: { sm6: true }
        },
        'invoice_notes': {
          hint: 'These will automatically be added to all invoices',
          persistentHint: true,
          flexAttrs: { sm6: true }
        },
        'receipt_notes': {
          hint: 'This will automatically be added to all receipts',
          persistentHint: true,
          flexAttrs: { sm6: true }
        },
        'statement_notes': {
          hint: 'This will automatically be added to all statements',
          persistentHint: true,
          flexAttrs: { sm6: true }
        }
        // 'snap_id': {
        //   label: 'SnapScan ID',
        //   hint: 'Your SnapScan ID is the short code under the Snapcode on your Merchant kit.',
        //   persistentHint: true
        // }
      }
    }
  },
  mounted () {
    if (!this.settings || this.settings.id) {
      this.get()
    }
    // if (this.touch !== 10) {
    //   this.get()
    // }
  },
  watch: {
    touch () {
      this.get()
    },
    value: {
      immediate: true,
      handler () {
        this.setSettings(this.value)
      }
    },
    getRequestStatus () {
      if (this.getRequestStatus === 200) {
        let settings = this.getObjectPath(this.getReq, 'result', {})
        this.setSettings(settings)
        // this.settings = settings
      }
    },
    saveRequestStatus () {
      if (this.saveRequestStatus === 200) {
        let settings = this.getObjectPath(this.saveReq, 'result', {})
        this.setSettings(settings)
        this.$emit('success', settings)
      }
    }
  },
  computed: {
    settingsId () {
      return this.getObjectPath(this.settings, 'id')
    },
    getRequestStatus () {
      return this.getReq.status
    },
    saveRequestStatus () {
      return this.saveReq.status
    },
    logoUploadPath () {
      return `/api/v3/spaces/${this.spaceId}/settings/${this.settingsId}/`
    },
    resizedLogoPicture () {
      if (this.logoPicture) {
        return this.imageKitUrl(this.logoPicture, 'n-avatar_md')
      }
      return null
    }
  },
  methods: {
    setValid (isValid) {
      this.isValid = isValid
    },
    setSettings (data) {
      if (data) {
        if (data.id) { this.settings.id = data.id }
        if (data.logo_picture) {
          this.logoPicture = data.logo_picture
        }
        this.fields.forEach((field) => {
          let value = data[field]
          if (!value) { value = null }
          Vue.set(this.settings, field, value)
        })
      }
    },
    get () {
      if (this.settingsId) {
        this.getReq.kwargs = {spaceId: this.spaceId}
        this.getReq.resourceId = this.settingsId
        this.$request('get', this.getReq)
      }
    },
    save () {
      let data = JSON.stringify(this.settings)
      this.saveReq.data = data
      this.saveReq.kwargs = {spaceId: this.spaceId}
      this.saveReq.resourceId = this.settings.id
      this.$request('save', this.saveReq)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// InvoiceSettings.vue?75daa72f